// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qb_a bho_sn bho_va","ForumSearch__img":"qb_b","ForumSearch__searchAdsAndShoppingAds":"qb_c","ForumSearch__results--empty":"qb_e"};